import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronUp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 8,
	viewBox: "0 0 14 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.8945 5.98828C13.332 6.39844 13.3594 7.08203 12.9219 7.51953C12.5117 7.95703 11.8281 7.98438 11.3906 7.54688L7.125 3.47266L2.83203 7.54688C2.39453 7.98438 1.71094 7.95703 1.30078 7.51953C0.863281 7.08203 0.890625 6.39844 1.32812 5.98828L6.35938 1.17578C6.57812 0.957031 6.85156 0.875 7.125 0.875C7.37109 0.875 7.64453 0.957031 7.86328 1.17578L12.8945 5.98828Z",
		fill: "#37474F"
	})]
});
const ForwardRef = forwardRef(SvgChevronUp);
export { ForwardRef as ReactComponent };
